import { AttachmentPreviewHeader } from '@components/icons/AttachmentPreviewHeader'
import { Modal } from '@components/Modal'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Document, Page, pdfjs } from 'react-pdf'

import TrashIcon from '@/assets/icons/trash.svg'
import { Attachment } from '@/contexts/consultation'

pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString()

type AttachmentPreviewProps = {
  attachment: Attachment
  onClose: () => void
  onRemove: () => void
}

export const AttachmentPreview = ({ attachment, onClose, onRemove }: AttachmentPreviewProps) => {
  const { t } = useTranslation()
  const [numPages, setNumPages] = useState<number | null>(null)

  return (
    <Modal
      header={{
        icon: <AttachmentPreviewHeader customClassName="text-primary" />,
        title: t('attachmentPreview.title')
      }}
      onClose={onClose}
      dataTestId="attachment-preview"
    >
      <div className="flex flex-col items-center gap-4 rounded bg-white p-3 shadow-strong">
        {attachment.file.type === 'application/pdf' ? (
          <Document
            file={attachment.file}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages)
            }}
          >
            {Array.from(new Array(numPages), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                className="mt-1 border border-gray-text/25"
                pageNumber={index + 1}
                width={window.innerWidth - 100}
                renderAnnotationLayer={false}
                renderTextLayer={false}
              />
            ))}
          </Document>
        ) : (
          <img src={attachment.preview as string} className="w-full" />
        )}

        <button className="flex items-center gap-2 py-2" onClick={onRemove} data-testid="remove-attachment-button">
          <img src={TrashIcon} className="h-4 w-4" />
          <p className="text-sm font-bold uppercase">{t('button.remove')}</p>
        </button>
      </div>
    </Modal>
  )
}
